
import React, {Component} from "react";
import {Alert, Button, ButtonGroup} from "react-bootstrap";
import {dashboardService} from "../../../services/dashboard.service";

class PilotConference extends Component {


    handleAction = (action, type = "GET") => {
        if(type === "GET") {
            dashboardService.getDashboardAction(action)
                .then(res => this.props.reload());
        }
        else {
            dashboardService.setPowerManagement(action)
                .then(res => this.props.reload());
        }
    }


    render() {
        const { data, deviceGroup, screnarionSettings } = this.props;
        const first = deviceGroup;

        console.log(data);
        
        const buttonStyle = {height: "70px"}

        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <b><span className="card-title">
                                Tryb: <b>Konferencja</b>
                            </span></b>
                        </div>
                        <div className="card-body">
                            <Alert
                                variant={first.manualTurnOn ? 'success' : 'warning'}>
                                <h6 className={"m-0"}>
                                    {first.manualTurnOn ?
                                        `Tryb konferencyjny urchomiony` :
                                        `Wyłączony`
                                    }
                                </h6>
                            </Alert>

                            <ButtonGroup size="lg" className="mx-0 d-flex flex-row" style={buttonStyle} >
                                <Button variant={'outline-secondary'}
                                        active={first.manualTurnOn}
                                        onClick={() => this.handleAction(`turnonpcgroup/${first.id}`)}>
                                    Włącz tryb konferencyjny
                                </Button>
                                <Button variant={'outline-secondary'}
                                        active={!first.manualTurnOn}
                                        onClick={() => this.handleAction(`RestoreScheduleDeviceGroup/${first.id}`, "PATCH")}>
                                    Wyłącz  tryb konferencyjny
                                </Button>
                            </ButtonGroup>

                            <ButtonGroup size="lg" className="mt-4 mx-0 w-100" style={buttonStyle} >
                                <Button variant={'success'}
                                        onClick={() => window.location.href = data.expoFormUrl}>
                                    Edytuj zawartość ekranów
                                </Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PilotConference;